export default [
  {
    label:"",
    unit:"",
    rate: "",
    dfltqty: "",
    glacctnum: "",
  },
];
